import {
  Button,
  Card,
  CardContent,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import effect from "../../assets/images/contactuseffect.png";
import { grey, red } from "@mui/material/colors";
import React, { useState } from "react";
import { Business, Email, Person, Phone } from "@mui/icons-material";
import axios from "axios";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { styled } from "@mui/system";

const CustomTextarea = styled(TextareaAutosize)({
  "&::placeholder": {
    fontFamily: "HelNeu-Light",
    fontSize: "16px",
    color: "grey",
  },
});
const GetInTouchCard = () => {
  const [countryCode, setCountryCode] = useState("+91");
  const [companyName, setCompanyName] = useState("");
  const [contactName, setContactName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({
    companyName: "",
    contactName: "",
    email: "",
    phoneNumber: "",
    message: "",
  });
  const [requestPlaced, request] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const validateName = (name) => /^[a-zA-Z ]{2,30}$/.test(name);
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePhoneNumber = (phoneNumber) =>
    /^\+?[1-9]\d{9,14}$/.test(phoneNumber);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const newErrors = {};

    if (!validateName(contactName)) {
      newErrors.contactName =
        "Contact name must be 2-30 characters without symbols";
    }
    if (!validateName(companyName)) {
      newErrors.companyName =
        "Company name must be 2-30 characters without symbols";
    }
    if (!validateEmail(email)) {
      newErrors.email = "Invalid email address";
    }
    if (!validatePhoneNumber(phoneNumber)) {
      newErrors.phoneNumber = "Invalid phone number";
    }
    if (
      message.trim().split(/\s+/).length < 5 ||
      message.trim().split(/\s+/).length > 200
    ) {
      newErrors.message = "Message must be between 5 and 100 words";
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const requestBody = {
        body: JSON.stringify({
          email: email,
          companyName: companyName,
          contactName: contactName,
          phoneNumber: phoneNumber,
          message: message,
        }),
      };

      try {
        // console.log(JSON.stringify(requestBody));
        const response = await axios.post(
          "https://eu9odze5pj.execute-api.ap-south-1.amazonaws.com/testing/enquiry",
          requestBody,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        //console.log("Form submitted successfully:", response.data);
        alert(
          "Product Enquiry Initiated! Our team will be contacting you soon"
        );
        request(true);
      } catch (error) {
        //console.error("Error submitting form:", error);
        alert("Product Enquiry Failed");
      }
    }
  };

  const handleCountryCodeChange = (event) => {
    setCountryCode(event.target.value);
  };
  const handleMouseOver = () => {
    if (requestPlaced) setDisabled(true);
  };
  const handleMouseOut = () => {
    setDisabled(false);
  };

  const [ref, inView] = useInView();
  return (
    <motion.div
      ref={ref}
      initial={{ scale: 0.8 }}
      animate={{ scale: inView ? 1 : 0.5 }}
      transition={{ duration: 2 }}
      className="md:mx-auto mx-8"
    >
      <Card
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        sx={{
          borderRadius: 15,
          backgroundImage: effect,
          backgroundColor: grey,
          minHeight: 100,
          height: "auto",
          maxWidth: 500,
          minWidth: 100,
          alignContent: "center",
        }}
      >
        <CardContent sx={{ color: red }}>
          {disabled ? (
            <div className="flex flex-col align-middle text-center justify-center p-24 text-xl">
              Our Team will be contacting you soon!
            </div>
          ) : (
            <div className="flex flex-col ">
              <div className="p-5 text-left">
                <div className="font-HNmed text-3xl md:text-5xl my-1">
                  Get In Touch
                </div>
                <div className="font-HNlight text-xl text-[#75777C]">
                  You can reach us any time!
                </div>
              </div>
              <div>
                <OutlinedInput
                  disabled={requestPlaced}
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  sx={{
                    borderRadius: 10,
                    paddingX: 1,
                    marginY: 1,
                    width: { xs: "95%", md: "90%" },
                  }}
                  placeholder="Company Name"
                  startAdornment={
                    <InputAdornment position="start">
                      <Business className="m-2" />
                    </InputAdornment>
                  }
                />{" "}
                {errors.companyName && (
                  <div>
                    <label style={{ color: "red" }}>{errors.companyName}</label>
                  </div>
                )}
              </div>
              <div>
                <OutlinedInput
                  disabled={requestPlaced}
                  value={contactName}
                  onChange={(e) => setContactName(e.target.value)}
                  sx={{
                    borderRadius: 10,
                    paddingX: 1,
                    marginY: 1,
                    width: { xs: "95%", md: "90%" },
                  }}
                  placeholder="Contact Name"
                  startAdornment={
                    <InputAdornment position="start">
                      <Person className="m-2" />
                    </InputAdornment>
                  }
                />{" "}
                {errors.contactName && (
                  <div>
                    <label style={{ color: "red" }}>{errors.contactName}</label>
                  </div>
                )}
              </div>
              <div>
                <OutlinedInput
                  disabled={requestPlaced}
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{
                    borderRadius: 10,
                    paddingX: 1,
                    marginY: 1,
                    width: { xs: "95%", md: "90%" },
                  }}
                  placeholder="Email"
                  startAdornment={
                    <InputAdornment position="start">
                      <Email className="m-2" />
                    </InputAdornment>
                  }
                />
                {errors.email && (
                  <div>
                    <label style={{ color: "red" }}>{errors.email}</label>
                  </div>
                )}
              </div>
              <div>
                <OutlinedInput
                  disabled={requestPlaced}
                  sx={{
                    borderRadius: 10,
                    marginY: 1,
                    width: {
                      xs: "95%",
                      md: "90%",
                    },
                  }}
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="Phone number"
                  startAdornment={
                    <InputAdornment position="start">
                      <Phone />
                      <Select
                        value={countryCode}
                        onChange={handleCountryCodeChange}
                        sx={{
                          boxShadow: "none",
                          ".MuiOutlinedInput-notchedOutline": { border: 0 },
                        }}
                      >
                        <MenuItem value="+1">+1</MenuItem>
                        {/* Add more country codes as needed */}
                        <MenuItem value="+91">+91</MenuItem>
                      </Select>
                    </InputAdornment>
                  }
                />
                {errors.phoneNumber && (
                  <div>
                    <label style={{ color: "red" }}>{errors.phoneNumber}</label>
                  </div>
                )}
              </div>
              <div>
                <CustomTextarea
                  disabled={requestPlaced}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  minRows={3}
                  placeholder="How can we help?"
                  className="w-[95%] md:w-[90%] p-4 rounded-lg border"
                />
              </div>{" "}
              {errors.message && (
                <div>
                  <label style={{ color: "red" }}>{errors.message}</label>
                </div>
              )}
              <div>
                <Button
                  disabled={requestPlaced}
                  variant="contained"
                  onClick={handleSubmit}
                  sx={{ borderRadius: 10, marginY: 1, width: "70%" }}
                >
                  Submit
                </Button>
              </div>
              <Typography
                sx={{
                  color: "#8C8C8C",
                  paddingX: 10,
                  textShadow: "0 4 black",
                  fontSize: "10px",
                }}
              >
                By contacting us, you agree to our Terms of Service and Privacy
                Policy
              </Typography>
            </div>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default GetInTouchCard;
